export const vasOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]


export const variantOptions = ['Inhibitory TNF', 'Inhibitory IL-6', 'Inhibitory JAK', 'Inne']

export const tnfOptions = ['Certolizumab pegol', 'Adalimumab - Humira', 'Adalimumab inne', 'Etanercept', 'Golimumab', 'Infliksimab']

export const jakOptions = ['Upadacytynib (Rinvoq 15mg/dobę)', 'Tofacytynib', 'Filgotynib', 'Barycytynib']

export const combinationsOptions = ['Metotreksat', 'Sulfasalazyna', 'Leflunomid', 'Inne']